import type { ThresholdRule } from 'flow/service/rules';
import type { Action } from 'flow/store/engine/types';

export type RuleBuilderDragItem = {
  sourceActionId: Action['publicId'];
  rule: ThresholdRule;
};

export type GroupPosition = 'start' | 'end';

export const ruleBuilderEditMode = {
  /** Disables configurability and adds a ui treatment to indicate disabled state. */
  disabled: 'disabled',

  /** Default state of the editor. Allows rules to be configured. */
  editable: 'editable',

  /** Disables configurability, but does not add an additional ui treatment to indicate disabled state. */
  readOnly: 'readOnly',
} as const;

export type RuleBuilderEditMode = keyof typeof ruleBuilderEditMode;
